import * as _ from 'lodash';
import { gearDef } from '@/services/constants';
/**
 * This file is for dealing with what's coming back from /analyze
 */

const getGear = (score) => {
  return Object.keys(gearDef).reduce((accumulator, gearScore) => {
    if (score >= gearScore) accumulator = gearDef[gearScore];
    return accumulator;
  }, 1);
};

const getDimension = (scoreRow) => {
  let i = 0;
  const results = [];
  while (scoreRow[`dimension${i}Value`]) {
    results.push(scoreRow[`dimension${i}Value`]);
    i += 1;
  }
  return _.uniq(results).join(', ');
};

/**
 * Takes raw data, spits it out by dimension then element
 */
const getDimensionElementTotals = (scores) => {
  // initialize result
  const runningTotals = {
    totals: {
      elementScores: {

      }
    }
  };

  // add up across a dimension
  scores.forEach((scoreRow) => {
    const dimension = getDimension(scoreRow);
    if (!runningTotals[dimension]) {
      runningTotals[dimension] = {
        elementScores: {

        }
      };
    }
    if (!runningTotals[dimension].elementScores[scoreRow.elementName]) {
      runningTotals[dimension].elementScores[scoreRow.elementName] = {
        cumulativeScore: 0,
        responses: 0,
        averageScore: 0,
        numberOfResponses: 0,
        scoreBackwards: scoreRow.scoreBackwards,
        elementName: scoreRow.elementName
      };
    }
    if (!runningTotals.totals.elementScores[scoreRow.elementName]) {
      runningTotals.totals.elementScores[scoreRow.elementName] = {
        cumulativeScore: 0,
        responses: 0,
        numberOfResponses: 0,
        averageScore: 0,
        scoreBackwards: scoreRow.scoreBackwards,
        elementName: scoreRow.elementName
      };
    }

    runningTotals.totals.elementScores[scoreRow.elementName].responses += scoreRow.numberOfResponses;
    runningTotals.totals.elementScores[scoreRow.elementName].numberOfResponses += scoreRow.numberOfResponses;
    runningTotals.totals.elementScores[scoreRow.elementName].cumulativeScore += scoreRow.numberOfResponses * scoreRow.averageScore;
    runningTotals.totals.elementScores[scoreRow.elementName].averageScore = runningTotals.totals.elementScores[scoreRow.elementName].cumulativeScore / runningTotals.totals.elementScores[scoreRow.elementName].responses;
    runningTotals[dimension].elementScores[scoreRow.elementName].responses += scoreRow.numberOfResponses;
    runningTotals[dimension].elementScores[scoreRow.elementName].numberOfResponses += scoreRow.numberOfResponses;
    runningTotals[dimension].elementScores[scoreRow.elementName].cumulativeScore += scoreRow.numberOfResponses * scoreRow.averageScore;
    runningTotals[dimension].elementScores[scoreRow.elementName].averageScore = runningTotals[dimension].elementScores[scoreRow.elementName].cumulativeScore / runningTotals[dimension].elementScores[scoreRow.elementName].responses;
  });

  return runningTotals;
};

const getOverallScore = elementDimensionScores => {
  const elementScores = _.values(elementDimensionScores.reduce((accumulator, elementDimensionScore) => {
    if (!accumulator[elementDimensionScore.elementName]) {
      accumulator[elementDimensionScore.elementName] = JSON.parse(JSON.stringify(elementDimensionScore));
      accumulator[elementDimensionScore.elementName].cumulativeScore = 0;
      accumulator[elementDimensionScore.elementName].totalResponses = 0;
    }
    accumulator[elementDimensionScore.elementName].cumulativeScore += elementDimensionScore.averageScore * elementDimensionScore.numberOfResponses;
    accumulator[elementDimensionScore.elementName].totalResponses += elementDimensionScore.numberOfResponses;
    accumulator[elementDimensionScore.elementName].averageScore = accumulator[elementDimensionScore.elementName].cumulativeScore / accumulator[elementDimensionScore.elementName].totalResponses;
    return accumulator;
  }, {}));
  const sumOfScores = elementScores.reduce((accumulator, elementScore) => accumulator + (elementScore.scoreBackwards ? (5 - elementScore.averageScore) : elementScore.averageScore) , 0);
  const totalElements = elementScores.length;
  return (sumOfScores / totalElements -1 ) / 3 * 100;
};


export {
  getDimension,
  getDimensionElementTotals,
  getGear,
  getOverallScore
};



// WEBPACK FOOTER //
// ./src/services/analysis.js